import React, { useEffect, useMemo } from 'react';
import { Ramp , RampUnit } from "@playwire/pw-react-component";

import isEmpty from 'lodash/isEmpty';
import { Adsense } from '@ctrl/react-adsense';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile, isMobileOnly } from 'react-device-detect';
import mixpanel from 'mixpanel-browser';
import usePortal from 'react-useportal';
import LastResult from '../../components/LastResult 2.0';
import TableContainer from './components/TableContainer';
import NextMatch from '../../components/NextMatch';
import HomeCalendar from './components/HomeCalendar';
import {
  SignFreeAgentPopup,
  NotificationPopup,
  PlayerInfoPopup,
  DiscordRejoinPopup,
  WelcomePopup,
} from '../../components/Popup';
import { HomeTeamStat, TasksListPreloader, LeagueTeamsPreloader } from '../../components/ContentPreloaders';
import FallbackContentAnimation from '../../components/FallbackContentAnimation';
import TasksList from '../../components/TasksList';
import { homeGetHomeInitialData } from '../../redux/actions/Home';
import { getTasksList } from '../../redux/actions/Tasks';
// import { adsClickRequest } from '../../redux/actions/ads';
import { getPlayerInformation, leagueSetTeamInfo, leagueCreateCalendar } from '../../redux/actions/League';
import { showPopupWindow } from '../../redux/actions/Popups';
import { getUniverses } from '../../redux/actions/SignUp';
import { teamGetMyTeam, teamGetMyStrategy, showMobileSidebarSection } from '../../redux/actions/Team';
import { transferGetDataToSearchable } from '../../redux/actions/Transfers';
import { allowTour } from '../../redux/actions/TourControl';

import { getTourState } from '../../redux/selector/TourControl';
import { homeIsLoaded, homeData } from '../../redux/selector/Home';
import { tasksLoading, tasksData, tasksLoaded } from '../../redux/selector/Tasks';
import { getLoadingUniversesData } from '../../redux/selector/SignUp';
import { getMyAllSquad, getAcademyList, myTeamLoading, upcomingCalendarList, isStrategyLoading } from '../../redux/selector/Team';
import { getUser, isPremiumUser, isAuth } from '../../redux/selector/User';

import { getPlayerInformationSelector, calendarData } from '../../redux/selector/League';
import { getSearchPlayer } from '../../redux/selector/Transfers';

import { getPopupByName } from '../../redux/selector/Popups';
import {
  StyledBlockContainer,
  StyledNewWrapper,
  StyledLobbySection,
  StyledHomeColumn,
  StyledTeamName,
  StyledTeamStats,
  StyledInfoLabel,
  StyledRankingContainer,
  StyledSmallStats,
  StyledLeagueLabel,
  StyledTeamTextFields,
  SyledTopLeftSection,
  StyledHalfWidthSection,
  StyledTeamCard,
  StyledTeamInfo,
  StyledClubStack,
  StyledTodoStack,
  StyledMatchRow,
  StyledViewMore,
  StyledClubPulse,
  StyledClubStat,
  StyledClubStatValue,
  StyledClubStatLabel,
  StyledClubBody,
  StyledClubMeta,
  StyledClubMetaValue,
  StyledClubFormPills,
  StyledClubFormPill,
  StyledClubShortcuts,
  StyledClubShortcut,
  StyledClubShortcutLabel,
} from './styled';
import { toOrdinalSuffix } from '../../service/utils';
import { teamRank } from '../../service/data';
import { leagueForm } from '../../service/leagueTable';
import { POPUPS, ratingRangeStatus } from '../../service/constants';
import { shouldAutoStartTour, tourStorageValue } from '../../helpers/tour/locationToStorage';
import SectionHeading from '../../components/SectionHeading';
import { ReactComponent as ArrowUpRight } from '../../assets/img/arrow-up-right.svg';
import useLiveMatchPoll from '../../hooks/useLiveMatchPoll';

const FORM_SLOTS = 5;

const formatSigned = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  if (n > 0) return `+${n}`;
  return String(n);
};

const formatSquadRating = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'string') {
    const asNumber = Number(value);
    if (Number.isFinite(asNumber) && ratingRangeStatus[asNumber] != null) {
      return ratingRangeStatus[asNumber];
    }
    return value;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  if (ratingRangeStatus[n] != null) return ratingRangeStatus[n];
  const rounded = Math.round(n);
  if (ratingRangeStatus[rounded] != null) return ratingRangeStatus[rounded];
  return String(n);
};

const Home = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const isHomeLoaded = useSelector(homeIsLoaded);
  const isAuthenticated = useSelector(isAuth);
  const tasksPayload = useSelector(tasksData);
  const isTasksLoading = useSelector(tasksLoading);
  const isTasksLoaded = useSelector(tasksLoaded);
  const serverData = useSelector(getSearchPlayer);
  const userTeamData = useSelector(homeData);
  const { universesList } = useSelector(getLoadingUniversesData);
  const isPremium = useSelector(isPremiumUser);
  const isTourStart = useSelector(getTourState);

  const team = useSelector(getMyAllSquad);
  const academyList = useSelector(getAcademyList);
  const isTeamLoading = useSelector(myTeamLoading);
  const upcomingCalendar = useSelector(upcomingCalendarList);
  const calendarLoading = useSelector(isStrategyLoading);
  const leagueFixtures = useSelector(calendarData);
  const hideWelcomePopup = localStorage.getItem('hideWelcomePopup');
  useLiveMatchPoll(userTeamData?.matchRunning);
  useEffect(() => {
    dispatch(homeGetHomeInitialData());
    if (!hideWelcomePopup) {
      dispatch(showPopupWindow(POPUPS.WELCOME_POPUP, POPUPS.WELCOME_POPUP, false));
    }
    /* eslint-disable-next-line */
  }, [dispatch]);
  useEffect(() => {
    if (upcomingCalendar == null) {
      dispatch(teamGetMyStrategy());
    }
  }, [dispatch, upcomingCalendar]);
  useEffect(() => {
    if (!leagueFixtures?.currentDate) {
      dispatch(leagueCreateCalendar());
    }
  }, [dispatch, leagueFixtures?.currentDate]);
  useEffect(() => {
    try {
      mixpanel.track('Visit home page');
      if (!isAuthenticated) {
        mixpanel.track('Preview lobby');
      }
    } catch {
      /* Optional analytics must not break Home. */
    }
  }, []);

  useEffect(() => {
    if (serverData.length === 0) dispatch(transferGetDataToSearchable());
  }, [dispatch, serverData.length]);

  useEffect(() => {
    if (!isEmpty(userTeamData) && !userTeamData.inServer) {
      dispatch(showPopupWindow(POPUPS.REJOIN_DISCORD_POPUP, POPUPS.REJOIN_DISCORD_POPUP, false));
    }
  }, [dispatch, userTeamData, userTeamData.inServer]);

  const { playerId } = useParams();

  const { Portal } = usePortal({
    bindTo: document && document.querySelector('#modal'),
  });

  useEffect(() => {
    if (playerId) {
      dispatch(showPopupWindow(POPUPS.PLAYER_INFO_POPUP, POPUPS.PLAYER_INFO_POPUP, true));
      dispatch(getPlayerInformation(playerId, POPUPS.PLAYER_INFO_POPUP));
    }
  }, [playerId, dispatch]);

  useEffect(() => {
    if (isEmpty(universesList)) {
      dispatch(getUniverses(false));
    }
  }, [dispatch, universesList]);
  useEffect(() => {
    if (!isTasksLoaded) {
      dispatch(getTasksList());
    }
  }, [dispatch, isTasksLoaded]);

  useEffect(() => {
    const refreshTasks = () => {
      if (document.visibilityState === 'visible') {
        dispatch(getTasksList());
      }
    };
    document.addEventListener('visibilitychange', refreshTasks);
    window.addEventListener('focus', refreshTasks);
    return () => {
      document.removeEventListener('visibilitychange', refreshTasks);
      window.removeEventListener('focus', refreshTasks);
    };
  }, [dispatch]);

  useEffect(() => {
    if (isEmpty(team) && !isTeamLoading) {
      dispatch(teamGetMyTeam());
    }
  }, [dispatch, team, isTeamLoading]);

  useEffect(() => {
    const activeLocalStorageTourState = localStorage.getItem(tourStorageValue[location.pathname]);
    if (
      !isHomeLoaded &&
      !isTourStart &&
      hideWelcomePopup === 'true' &&
      !activeLocalStorageTourState &&
      shouldAutoStartTour()
    ) {
      dispatch(allowTour(true));
    }
  }, [isHomeLoaded, isTourStart, dispatch, location.pathname, hideWelcomePopup]);

  const popupData = useSelector(getPopupByName(POPUPS.NOTIFICATION_POPUP));
  const rejoinDiscordPopupData = useSelector(getPopupByName(POPUPS.REJOIN_DISCORD_POPUP));
  const playerInfoPopupData = useSelector(getPopupByName(POPUPS.PLAYER_INFO_POPUP));
  const welcomePopupData = useSelector(getPopupByName(POPUPS.WELCOME_POPUP));
  const freeAgentPopupData = useSelector(getPopupByName(POPUPS.FREE_AGENT_POPUP));
  const playerInfoData = useSelector(getPlayerInformationSelector);
  const { leagueName } = useSelector(getUser);
  const isFromRegister = localStorage.getItem('isFromRegister');
  const universeName =
    !isEmpty(universesList) &&
    leagueName &&
    universesList.find((universe) =>
      Array.isArray(universe?.leagues) &&
      universe.leagues.some((league) => league.code === leagueName)
    )?.name;
  useEffect(() => {
    if (universeName) {
      try {
        mixpanel.people.set({ 'Player universe name': universeName });
        mixpanel.register({ 'Player universe name': universeName });
      } catch {
        /* Optional analytics must not break Home. */
      }
    }
  }, [universeName]);

  const showTeamDetails = () => {
    dispatch(leagueSetTeamInfo({ _id: userTeamData.teamId }, isMobileOnly));
    if (isMobileOnly) {
      dispatch(showMobileSidebarSection('teamInfo'));
    } else {
      dispatch(showPopupWindow(POPUPS.TEAM_INFO_POPUP, POPUPS.TEAM_INFO_POPUP, true));
    }
  };

  const goToLeague = () => {
    history.push('/league');
  };
  const goToCup = () => {
    history.push('/domestic-cup');
  };

  const clubWaiting = Boolean(isHomeLoaded) || !userTeamData?.teamName;
  const tableWaiting = clubWaiting && !userTeamData?.rankingTable;
  const todosWaiting = Boolean(isTasksLoading) && !tasksPayload;

  const clubPulse = useMemo(() => {
    const academyIds = new Set(academyList || []);
    const firstTeam = (team || []).filter(
      (player) =>
        !player.loanedOut &&
        !academyIds.has(player._id) &&
        player.academy?.status !== 1
    );
    const injured = firstTeam.filter(
      (player) => player.form_range === -1 || player.form === 'Injured'
    ).length;
    const listed = firstTeam.filter((player) => player.listed).length;
    const rating = formatSquadRating(userTeamData?.players_avg_rating);
    const stats = [];
    if (rating) {
      stats.push({ key: 'rating', label: 'Rating', value: rating });
    }
    if (firstTeam.length > 0) {
      stats.push({
        key: 'injured',
        label: 'Injured',
        value: String(injured),
        tone: injured > 0 ? 'danger' : undefined,
      });
      stats.push({ key: 'listed', label: 'Listed', value: String(listed) });
      stats.push({ key: 'squad', label: 'Squad', value: String(firstTeam.length) });
    }
    return stats;
  }, [academyList, team, userTeamData?.players_avg_rating]);

  const clubSeason = useMemo(() => {
    const table = userTeamData?.rankingTable;
    const teamId = userTeamData?.teamId;
    if (!Array.isArray(table) || !teamId) return null;
    const row = table.find((entry) => String(entry?._id) === String(teamId));
    if (!row) return null;
    const win = Number(row.win);
    const draw = Number(row.draw);
    const loss = Number(row.loss);
    const points = Number(row.points);
    const gd = formatSigned(row.gd);
    const hasRecord = [win, draw, loss].every(Number.isFinite);
    const played = Number.isFinite(Number(row.played))
      ? Number(row.played)
      : hasRecord
        ? win + draw + loss
        : 0;
    if (played <= 0) return null;
    if (!hasRecord && !Number.isFinite(points)) return null;
    return {
      record: hasRecord ? `${win}–${draw}–${loss}` : null,
      points: Number.isFinite(points) ? points : null,
      gd,
    };
  }, [userTeamData?.rankingTable, userTeamData?.teamId]);

  const clubForm = useMemo(() => {
    const teamId = userTeamData?.teamId;
    if (!teamId) return [];
    const byTeam = leagueForm(leagueFixtures?.matches, FORM_SLOTS);
    return byTeam[String(teamId)]?.results || [];
  }, [leagueFixtures?.matches, userTeamData?.teamId]);

  const clubSeasonLine = useMemo(() => {
    if (!clubSeason) return null;
    const parts = [];
    if (clubSeason.record) parts.push(clubSeason.record);
    if (clubSeason.points != null) parts.push(`${clubSeason.points} pts`);
    if (clubSeason.gd != null) parts.push(`${clubSeason.gd} GD`);
    return parts.length ? parts.join(' · ') : null;
  }, [clubSeason]);


  /*   useEffect(() => {
    const handleAdsClick = () => {
      if (document.activeElement === document.querySelector('iframe')) {
        dispatch(adsClickRequest());
      }
    };

    window.addEventListener('blur', handleAdsClick);
    return () => {
      window.removeEventListener('blur', handleAdsClick);
    };
  }, []); */

  return (
    <>
      <StyledNewWrapper>
        {!isEmpty(welcomePopupData) && !hideWelcomePopup && (
          <Portal>
            <WelcomePopup popupName={POPUPS.WELCOME_POPUP} />
          </Portal>
        )}

        {!isEmpty(popupData) && isFromRegister && (
          <Portal>
            <NotificationPopup
              popupName={POPUPS.NOTIFICATION_POPUP}
              closeCallback={() => {
                localStorage.removeItem('isFromRegister');
              }}
            />
          </Portal>
        )}
        {!isEmpty(playerInfoPopupData) && (
          <Portal>
            <PlayerInfoPopup popupName={POPUPS.PLAYER_INFO_POPUP} playerInfoData={playerInfoData} />
          </Portal>
        )}
        {!isEmpty(rejoinDiscordPopupData) && isAuthenticated && (
          <Portal>
            <DiscordRejoinPopup popupName={POPUPS.REJOIN_DISCORD_POPUP} />
          </Portal>
        )}
        {!isEmpty(freeAgentPopupData) && (
          <Portal>
            <SignFreeAgentPopup
              id={freeAgentPopupData.id}
              popupName={POPUPS.FREE_AGENT_POPUP}
              cash={userTeamData.cash_summary}
              deselectClicked={() => { }}
            />
          </Portal>
        )}
        <StyledBlockContainer>
          <StyledLobbySection>
            <StyledHomeColumn>
              <SyledTopLeftSection>
                <StyledClubStack>
                  <SectionHeading
                    title="Club"
                    action={
                      <StyledViewMore to="/team/squad">
                        View squad
                        <ArrowUpRight />
                      </StyledViewMore>
                    }
                  />
                  <StyledTeamInfo>
                    <FallbackContentAnimation loading={clubWaiting} fallback={<HomeTeamStat />}>
                      <StyledTeamName>
                        <StyledTeamCard onClick={showTeamDetails}>
                          {userTeamData.symbol && <img src={userTeamData.symbol} alt="team logo" />}
                          <StyledTeamTextFields>
                            <h1>{userTeamData.teamName}</h1>
                            <StyledLeagueLabel>{userTeamData.leagueName}</StyledLeagueLabel>
                          </StyledTeamTextFields>
                          <StyledRankingContainer>
                            {userTeamData.current_season_ranking !== -1 && (
                              <StyledInfoLabel
                                onClick={(event) => {
                                  event.stopPropagation();
                                  goToLeague();
                                }}
                              >
                                {toOrdinalSuffix(userTeamData.current_season_ranking + 1)} in league
                              </StyledInfoLabel>
                            )}
                            {userTeamData.current_cup_ranking !== -1 && (
                              <StyledInfoLabel
                                onClick={(event) => {
                                  event.stopPropagation();
                                  goToCup();
                                }}
                              >
                                Cup {teamRank[userTeamData.current_cup_ranking]}
                              </StyledInfoLabel>
                            )}
                          </StyledRankingContainer>
                        </StyledTeamCard>
                      </StyledTeamName>
                      <StyledClubBody>
                        {(clubSeasonLine || clubForm.length > 0) && (
                          <StyledClubMeta>
                            {clubSeasonLine && (
                              <StyledClubMetaValue>{clubSeasonLine}</StyledClubMetaValue>
                            )}
                            {clubForm.length > 0 && (
                              <StyledClubFormPills aria-label="Last five league results">
                                {clubForm.map((result, index) => (
                                  <StyledClubFormPill
                                    key={`${result}-${index}`}
                                    $result={result}
                                  >
                                    {result}
                                  </StyledClubFormPill>
                                ))}
                              </StyledClubFormPills>
                            )}
                          </StyledClubMeta>
                        )}
                        <StyledClubShortcuts>
                          <StyledClubShortcut to="/team/strategy">
                            <StyledClubShortcutLabel>Set strategy</StyledClubShortcutLabel>
                            <ArrowUpRight />
                          </StyledClubShortcut>
                          <StyledClubShortcut to="/team/development">
                            <StyledClubShortcutLabel>Development</StyledClubShortcutLabel>
                            <ArrowUpRight />
                          </StyledClubShortcut>
                          <StyledClubShortcut to="/transfers">
                            <StyledClubShortcutLabel>Transfers</StyledClubShortcutLabel>
                            <ArrowUpRight />
                          </StyledClubShortcut>
                        </StyledClubShortcuts>
                      </StyledClubBody>
                      {clubPulse.length > 0 ? (
                        <StyledClubPulse>
                          {clubPulse.map((stat) => (
                            <StyledClubStat key={stat.key} to="/team/squad">
                              <StyledClubStatValue $tone={stat.tone}>
                                {stat.value}
                              </StyledClubStatValue>
                              <StyledClubStatLabel>{stat.label}</StyledClubStatLabel>
                            </StyledClubStat>
                          ))}
                        </StyledClubPulse>
                      ) : null}
                    </FallbackContentAnimation>
                  </StyledTeamInfo>
                </StyledClubStack>
                <StyledTodoStack>
                  <SectionHeading title="To do" />
                  <StyledTeamStats>
                    <StyledSmallStats>
                      <FallbackContentAnimation
                        loading={todosWaiting}
                        fallback={<TasksListPreloader />}
                      >
                        {tasksPayload ? (
                          <TasksList tasksPayload={tasksPayload} />
                        ) : null}
                      </FallbackContentAnimation>
                    </StyledSmallStats>
                  </StyledTeamStats>
                </StyledTodoStack>
              </SyledTopLeftSection>

              <StyledHalfWidthSection>
                <FallbackContentAnimation
                  loading={tableWaiting}
                  repeat="10"
                  fallback={
                    <LeagueTeamsPreloader
                      style={{
                        width: `${isMobile ? '100%' : '600px'}`,
                        height: '38px',
                      }}
                    />
                  }
                >
                  {userTeamData && userTeamData.rankingTable && (
                    <TableContainer
                      ranking={userTeamData.rankingTable}
                      leagueName={userTeamData.leagueName}
                    />
                  )}
                </FallbackContentAnimation>
              </StyledHalfWidthSection>
            </StyledHomeColumn>

            <StyledHomeColumn>
              <StyledMatchRow>
                <NextMatch
                  isLoading={clubWaiting}
                  data={userTeamData}
                  teamKit={userTeamData?.teamKit}
                  opponentKit={userTeamData?.opponentKit}
                />
                <HomeCalendar
                  data={upcomingCalendar}
                  timezone={userTeamData?.timezone}
                  isLoading={calendarLoading || upcomingCalendar == null}
                  teamId={userTeamData?.teamId}
                  afterDate={userTeamData?.matchRunning?.match_date || userTeamData?.next_match?.match_date}
                  afterOpponentId={
                    (userTeamData?.matchRunning || userTeamData?.next_match)?.home_team?._id ===
                    userTeamData?.teamId
                      ? (userTeamData?.matchRunning || userTeamData?.next_match)?.away_team?._id
                      : (userTeamData?.matchRunning || userTeamData?.next_match)?.home_team?._id
                  }
                />
              </StyledMatchRow>
              {!isEmpty(userTeamData?.last_match?.results) && (
                <LastResult
                  isLoading={clubWaiting && isEmpty(userTeamData?.last_match)}
                  matchDate={userTeamData?.last_match?.match_date}
                  our_team={userTeamData?.last_match?.results?.home_team}
                  away_team={userTeamData?.last_match?.results?.away_team}
                  isDomesticCup={userTeamData?.last_match?.domestic_cup}
                  isFriendly={Boolean(userTeamData?.last_match?.friendly)}
                  timezone={userTeamData?.timezone}
                  match={userTeamData?.last_match}
                />
              )}
            </StyledHomeColumn>
          </StyledLobbySection>
        </StyledBlockContainer>

        {/* Only load this component once, at the top most level of your app */}
        {!isPremium && (
          <Ramp publisherId="1025083" id="74579" />
        )}
        {/* Place this component as needed for all in-page units */}
       {/*  {!isPremium && (<RampUnit
          type="dfp-med-rect"
          cssClass="leaderboard"
        />)} */}
{/*         {!isPremium && (
          <Adsense
            client={`${!isPremium ? 'ca-pub-2739224896366063' : ''}`}
            slot={`${!isPremium ? '9437045662' : ''}`}
            style={{
              width: '100%',
              height: `${!isPremium ? 300 : 0}`,
              display: `${!isPremium ? 'flex' : 'none'}`,
              flexDirection: 'center',
              marginTop: '20px',
            }}
            layout="in-article"
            format="fluid"
          />
        )} */}
      </StyledNewWrapper>
    </>
  );
};

export default Home;
